// What the /admin Statistics tab knows of solo games (owner 2026-10-30: "ile osób gra, w jakiego pasjansa"): a game's
// first move and a win, guests too (the ranking's wins are logged-in players only). One small beacon each, no answer
// is read; nothing else is sent. Not offline; in the e2e tests only when a test turns it on (many count requests).
import { env } from '../env';
import { firstReportToday, winLineGroup } from './winLine';

const on = (): boolean => {
  if (env.appTarget === 'offline') return false;
  if (!window.__E2E__) return true;
  try {
    return localStorage.getItem('solitaire_storage:play-report-e2e') === 'on';
  } catch {
    return false;
  }
};

const send = (body: Record<string, unknown>): void => {
  const json = JSON.stringify(body);
  const url = `${env.fullAddr}stats/play`;
  try {
    if (navigator.sendBeacon?.(url, new Blob([json], { type: 'application/json' }))) return;
    void fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: json, credentials: 'same-origin', keepalive: true }).catch(() => undefined);
  } catch {
    // only a count
  }
};

export function reportPlay(game: string, won: boolean): void {
  if (!on()) return;
  const wl = winLineGroup();
  send({ game, ...(won ? { won: true } : {}), ...(wl ? { wl } : {}), ...(wl && firstReportToday() ? { day: true } : {}) });
}

/** The win line's half split: a click on it, a lobby opened (from anywhere), an online game started; `named`: the line
 *  showed a waiting player's name, `nclick`: a click on such a line. */
export function reportWinLine(ev: 'click' | 'lobby' | 'games' | 'named' | 'nclick'): void {
  if (!on()) return;
  const wl = winLineGroup();
  if (wl) send({ wl, ev });
}
